import React from "react";

const PDFDownload = ({
	className = "ride-item-download__pdf",
	url = "",
	fileSize = false,
	text = "Download route PDF",
	isDownload = true,
}) =>
	url ? (
		<div className={ className }>
			<a
				href={ url }
				className={ `btn btn-download ${ !isDownload ? "btn-download--no-icon" : ""
					}` }
				download={ isDownload }
			>
				{ text }{ " " }
				{ fileSize && (
					<small
						style={ {
							display: "block",
							marginTop: ".25rem",
							fontSize: ".7em",
						} }
					>
						({ fileSize })
					</small>
				) }
			</a>
		</div>
	) : null;

export default PDFDownload;



// WEBPACK FOOTER //
// ./src/components/PDFDownload.js